<template>
  <div class="login-card-heading">
    <h1 class="text-title uppercase text-center">
      {{ title }}
    </h1>

    <p
      v-if="description"
      class="login-card-text text-highlight text-center text-neutral-clear font-normal mt-4"
    >
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: "LoginCardHeading",

  props: {
    title: {
      type: String,
      required: true
    },

    description: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.login-card-heading
  margin-bottom 8px

  @media screen and (min-width: 940px)
    margin-bottom 32px
</style>
